.avatar {
  aspect-ratio: 1;
  background: var(--color-bg-raised);
  border: var(--border-width-3) var(--border-style) var(--color-border);
  box-shadow: var(--shadow-pixel-lg);
  padding: var(--space-3);
  display: grid;
  place-items: center;
  overflow: hidden;
  transition: transform var(--transition-fast),
    box-shadow var(--transition-fast);
}

.avatar:hover {
  transform: translate(-2px, -2px);
  box-shadow: 8px 8px 0 0 var(--color-shadow);
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Size presets — `md` matches the original Hero box dimensions. */
.size_sm {
  width: clamp(72px, 12vw, 120px);
}

.size_md {
  width: clamp(180px, 32vw, 320px);
}

.size_lg {
  width: clamp(240px, 42vw, 420px);
}

@media (max-width: 820px) {
  .size_md {
    width: clamp(160px, 50vw, 240px);
  }
}
